"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualProfitAttributable = AnnualProfitAttributable;
exports.EmployeeIdentity = EmployeeIdentity;
exports.GrossProfit = GrossProfit;
exports.IndustrySector = IndustrySector;
exports.ReplaceEmployeeYears = ReplaceEmployeeYears;
exports.ShortTermAssets = ShortTermAssets;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _KeyEmployeeWizardCalc = require("./KeyEmployeeWizardCalc.config");
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function EmployeeIdentity(_ref) {
  var _errors$employees, _touched$employees, _values$employees, _errors$employees2;
  var {
    errors,
    touched,
    values,
    i
  } = _ref;
  var fieldName = 'employeeId';
  var label = 'Employee Name';
  var type = 'text';
  var inputMode = 'text';
  var maxLength = '200';
  var placeholder = '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName + i
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$employees = errors.employees) === null || _errors$employees === void 0 || (_errors$employees = _errors$employees[i]) === null || _errors$employees === void 0 ? void 0 : _errors$employees[fieldName]) && (touched === null || touched === void 0 || (_touched$employees = touched.employees) === null || _touched$employees === void 0 || (_touched$employees = _touched$employees[i]) === null || _touched$employees === void 0 ? void 0 : _touched$employees[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    "aria-label": _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "employees[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$employees = values.employees) === null || _values$employees === void 0 || (_values$employees = _values$employees[i]) === null || _values$employees === void 0 ? void 0 : _values$employees[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$employees2 = errors.employees) === null || _errors$employees2 === void 0 || (_errors$employees2 = _errors$employees2[i]) === null || _errors$employees2 === void 0 ? void 0 : _errors$employees2[fieldName])));
}
function AnnualProfitAttributable(_ref2) {
  var _errors$employees3, _touched$employees2, _values$employees2, _errors$employees4;
  var {
    errors,
    touched,
    values,
    i
  } = _ref2;
  var fieldName = 'annualProfitAttributable';
  var label = 'Profit attributable to Employee';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName + i
  }, label, ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: _KeyEmployeeWizardCalc.popoverConfig.annualProfitAttributableText
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$employees3 = errors.employees) === null || _errors$employees3 === void 0 || (_errors$employees3 = _errors$employees3[i]) === null || _errors$employees3 === void 0 ? void 0 : _errors$employees3[fieldName]) && (touched === null || touched === void 0 || (_touched$employees2 = touched.employees) === null || _touched$employees2 === void 0 || (_touched$employees2 = _touched$employees2[i]) === null || _touched$employees2 === void 0 ? void 0 : _touched$employees2[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    "aria-label": _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "employees[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$employees2 = values.employees) === null || _values$employees2 === void 0 || (_values$employees2 = _values$employees2[i]) === null || _values$employees2 === void 0 ? void 0 : _values$employees2[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, '%'))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$employees4 = errors.employees) === null || _errors$employees4 === void 0 || (_errors$employees4 = _errors$employees4[i]) === null || _errors$employees4 === void 0 ? void 0 : _errors$employees4[fieldName])));
}
function ReplaceEmployeeYears(_ref3) {
  var _errors$employees5, _touched$employees3, _values$employees3, _errors$employees6;
  var {
    errors,
    touched,
    values,
    i
  } = _ref3;
  var fieldName = 'replaceEmployeeYears';
  var label = 'Years to fully replace Employee';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '2';
  var placeholder = '00';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName + i
  }, label, ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: _KeyEmployeeWizardCalc.popoverConfig.replaceEmployeeYearsText
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$employees5 = errors.employees) === null || _errors$employees5 === void 0 || (_errors$employees5 = _errors$employees5[i]) === null || _errors$employees5 === void 0 ? void 0 : _errors$employees5[fieldName]) && (touched === null || touched === void 0 || (_touched$employees3 = touched.employees) === null || _touched$employees3 === void 0 || (_touched$employees3 = _touched$employees3[i]) === null || _touched$employees3 === void 0 ? void 0 : _touched$employees3[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    "aria-label": _KeyEmployeeWizardCalc.idPrefix + fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "employees[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$employees3 = values.employees) === null || _values$employees3 === void 0 || (_values$employees3 = _values$employees3[i]) === null || _values$employees3 === void 0 ? void 0 : _values$employees3[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$employees6 = errors.employees) === null || _errors$employees6 === void 0 || (_errors$employees6 = _errors$employees6[i]) === null || _errors$employees6 === void 0 ? void 0 : _errors$employees6[fieldName])));
}

// Other Details
function GrossProfit(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'aveGrossProfitPrior3YearsAmount';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName,
    label: "Average Gross Profit",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _KeyEmployeeWizardCalc.popoverConfig.aveGrossProfitText
  });
}
function ShortTermAssets(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'shortTermAssetsEstimates';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName,
    label: "Estimated Short-Term Assets Value",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _KeyEmployeeWizardCalc.popoverConfig.shortTermAssetsText
  });
}

// DROPDOWN
function IndustrySector(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "industrySector",
    setFieldValue: setFieldValue,
    values: values,
    label: "Industry",
    placeholderText: "Select one",
    dataArray: _KeyEmployeeWizardCalc.dropdownOptions.industrySectorArray,
    calcName: _KeyEmployeeWizardCalc.calcName
  }));
}